import _ from 'lodash';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
const getRangeOfYears = (minDate, maxDate) => {
    const minYear = minDate.getFullYear();
    const maxYear = maxDate.getFullYear();
    return _.range(minYear, maxYear + 1).map((year) => ({ id: year, text: year.toString() }));
};
const getRangeOfMonths = () => _.range(0, 12).map((month) => ({
    id: month,
    text: formatDate(new Date(2023, month), { format: 'dateFullMonth' }),
}));
const getRangeOfDays = () => _.range(1, 32).map((day) => ({ id: day, text: day.toString() }));
const getNumberOfDaysInMonth = (month) => {
    const date = new Date(2023, month, 0);
    return date.getDate();
};
export const getDates = (minDate, maxDate) => {
    const years = getRangeOfYears(minDate, maxDate);
    const months = getRangeOfMonths();
    const days = getRangeOfDays();
    months.forEach((month) => {
        const numberOfDays = getNumberOfDaysInMonth(month.id + 1);
        month.days = days.slice(0, numberOfDays);
    });
    const firstYear = _.first(years);
    const lastYear = _.last(years);
    const minDateMonth = minDate.getMonth();
    const maxDateMonth = maxDate.getMonth();
    firstYear.months = months.filter(({ id }) => id >= minDateMonth);
    lastYear.months = (lastYear.months || months).filter(({ id }) => id <= maxDateMonth);
    const firstMonth = Object.assign({}, _.first(firstYear.months)); // equal days object
    const lastMonth = Object.assign({}, _.last(lastYear.months)); // equal days object
    const minDateDay = minDate.getDate();
    const maxDateDay = maxDate.getDate();
    const isSameMonths = firstYear.id === lastYear.id && lastMonth.id === firstMonth.id;
    const firstDays = firstMonth.days.filter(({ id }) => id >= minDateDay);
    const lastDays = (isSameMonths ? firstDays : lastMonth.days).filter(({ id }) => id <= maxDateDay);
    firstMonth.days = firstDays;
    lastMonth.days = lastDays;
    firstYear.months[0] = firstMonth;
    lastYear.months[lastYear.months.length - 1] = lastMonth;
    return { years: _.orderBy(years, ['id'], 'desc'), defaultMonths: months };
};
export const getDayWithinDaysRange = (day, daysList) => {
    var _a, _b;
    if (_.isEmpty(daysList) || !day)
        return undefined;
    else if (day > ((_a = _.last(daysList)) === null || _a === void 0 ? void 0 : _a.id))
        return _.last(daysList).id;
    else if (day < ((_b = _.first(daysList)) === null || _b === void 0 ? void 0 : _b.id))
        return _.first(daysList).id;
    return day;
};
export const getMonthWithinMonthsRange = (month, monthsList) => {
    const firstMonth = _.first(monthsList);
    const lastMonth = _.last(monthsList);
    if (month >= firstMonth.id && month <= lastMonth.id)
        return month;
    else if (month > lastMonth.id)
        return lastMonth.id;
    else if (month < firstMonth.id)
        return firstMonth.id;
};
